import React from 'react';
import style from "./App.module.scss";

export const App = () => {
    return (
        <div className={style.hideMode}>
            <span className={style.fundfix}>fundfix</span>
        </div>
    );
};

